import React, {useId} from 'react';
import {appText} from '../../../assets/text/appText';
import TooltipQuestionMark from '../../TooltipQuestionMark';
import styles from './TextInput2.module.css';
import {eye, eyeOff} from '../../../assets/images';

export type TextInputUIType = 'standard' | 'pill' | 'box' | 'minimal';
export type InputType = 'text' | 'email' | 'password' | 'number' | 'tel';

interface Props {
  type?: InputType;
  value: string;
  onFocusFunc?: () => void;
  onBlurFunc?: () => void;
  onChange: (value: string) => void;
  onKeyDownFunc?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder: string;
  label?: string;
  maxCharacters?: number;
  minCharacters?: number;
  fieldError?: boolean;
  disabled?: boolean;
  isMandatory?: boolean;
  uiType?: TextInputUIType;
  helpTip?: string;
  className?: string;
}

const TextInput2 = React.memo(
  ({
    type = 'text',
    value,
    onChange,
    placeholder,
    label,
    maxCharacters,
    fieldError,
    disabled,
    isMandatory,
    uiType,
    minCharacters,
    onFocusFunc,
    onBlurFunc,
    onKeyDownFunc,
    helpTip,
    className,
  }: Props) => {
    const [showPassword, setShowPassword] = React.useState(false);
    const id = useId();
    const getRootClass = () => {
      switch (uiType) {
        case 'pill':
          return styles.pill;
        case 'box':
          return styles.box;
        case 'minimal':
          return styles.minimal;
        case 'standard':
        default:
          return styles.standart;
      }
    };

    return (
      <div className={`${className ? className : ''} ${getRootClass()}`}>
        {label && (
          <div>
            <label htmlFor={id}>
              {label}
              {isMandatory && (
                <span className={styles.mandatoryIndicator}>*</span>
              )}
            </label>
            {helpTip && <TooltipQuestionMark text={helpTip} />}
          </div>
        )}
        <div className={styles.inputContainer}>
          <input
            id={id}
            type={type == 'password' && showPassword ? 'text' : type}
            value={value}
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder}
            onFocus={onFocusFunc}
            onBlur={onBlurFunc}
            onKeyDown={onKeyDownFunc}
            className={`${fieldError ? styles.error : ''}`}
            maxLength={maxCharacters}
            disabled={disabled}
          />
          {type === 'password' && (
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className={styles.passwordEye}>
              <img src={showPassword ? eyeOff : eye} alt="eye" />
            </button>
          )}
        </div>
        <div className={styles.maxMinCharacters}>
          {minCharacters && (
            <span>{appText.minimumCharacters(minCharacters)}</span>
          )}
          {maxCharacters && (
            <span>
              {value.length} / {maxCharacters}
            </span>
          )}
        </div>
      </div>
    );
  },
);

export default TextInput2;
